export const INELIGIBLE_URL = 'vehicle-not-eligible';
